// extracted by mini-css-extract-plugin
export default {"fileRankLabel":"TileLayer_pc_fileRankLabel__-BVQU","tileLayer":"TileLayer_pc_tileLayer__c+uYo"};